import { ArrayField } from '@measured/puck';

import { IconName, getIconNames } from '../../../../../components/atoms/icon/icon-utils';

type TabType = {
  readonly name: string;
  readonly slug: string;
  readonly content: React.ReactNode;
  readonly icon?: IconName;
};

type TabsConfigReturn = {
  defaultValue: TabType[];
  fieldConfig: ArrayField<TabType[]>;
};

const createReportTabsConfig = (): TabsConfigReturn => {
  const iconNames = getIconNames();

  return {
    defaultValue: [
      {
        name: 'Tab 1',
        slug: 'tab-1',
        content: [],
      },
    ],
    fieldConfig: {
      arrayFields: {
        content: {
          type: 'slot',
        },
        name: {
          label: 'Name',
          type: 'text',
        },
        slug: {
          label: 'Slug',
          type: 'text',
        },
        icon: {
          label: 'Icon',
          type: 'select',
          options: [{ label: 'Select icon...', value: '' }].concat(
            iconNames.map((iconName) => ({
              label: iconName,
              value: iconName,
            }))
          ),
        },
      },
      defaultItemProps: {
        name: 'New Tab',
        slug: 'new-tab',
        content: [],
      },
      getItemSummary: ({ name }: TabType) => name,
      label: 'Tabs',
      max: 5,
      min: 0,
      type: 'array',
    },
  };
};

export { createReportTabsConfig };

export type { TabType };
